import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import copyToClipboard from '@functions/copyToClipboard'
import { confirmDelete } from '@functions/entity'

import useTrainingCourse from '@hooks/useTrainingCourse'

type TrainingCourseToolsProps = {
  trainingCoursePayload: ReturnType<typeof useTrainingCourse>,
}

const TrainingCourseTools = (props: TrainingCourseToolsProps) => {
  const { trainingCoursePayload } = props

  const {
    callbacks: {
      createOrDuplicateTrainingCourse,
      deleteTrainingCourse: deleteFn,
    },
    loading,
    urls: { linkUrl },
  } = trainingCoursePayload

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    options: { shouldRedirect: true },
    strings: { entityName: 'Training Course' },
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCopy} />}
        loading={loading}
        onClick={() => copyToClipboard(linkUrl)}
        size="medium"
      >
        Copy Link to Course
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCopy} />}
        loading={loading}
        marginTop="medium"
        onClick={() => createOrDuplicateTrainingCourse()}
        size="medium"
      >
        Duplicate Course
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faTrashAlt} />}
        loading={loading}
        marginTop="medium"
        onClick={() => confirmDelete(confirmDeletePayload)}
        size="medium"
      >
        Delete Training Course
      </Button>
    </Tools>
  )
}

export default TrainingCourseTools
